import {isBoolean, isObject} from 'lodash';
import {AnyObject} from 'types';

export const redirect = (arg: string | AnyObject, replace?: boolean) => {
  if (isObject(arg) && typeof arg.url === 'string') {
    arg = arg.url;
  }
  window.dispatchEvent(new CustomEvent('redirect', {
    detail: {
      url: arg,
      replace: isBoolean(replace) ? replace : undefined
    }
  }));
};
